import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import planner from "./planner.png";
import chat from "./chat.png";
const Tourism = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Products | Eco-Rolling AI</title></Helmet>
      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>

          <h1>Eco-Rolling AI <br/> The Agentic System for Travel & Tourism</h1>
          <p className={classes['mb-1']}>
            <strong> Eco-Rolling AI </strong>is a modular, agentic AI suite that
            <strong>transforms operational complexity into sustainable efficiency</strong>
            and seamless traveler experiences, ensuring <strong>profitability</strong>
            moves in harmony with <strong>planet-friendly</strong> operations.
          </p>

          <hr className={classes['bh-divider']}/>
          <h2 className={classes['project-subtitle2']}> Eco-Rolling Intelligent Planner Travel </h2>
          <p>

            The <strong>Intelligent Planner Travel </strong> system is an agentic network of
            collaborating AI modules designed to <strong>transform </strong>
            raw travel aspirations into
            <strong> perfectly executed, successful journeys.</strong>
            It operates proactively, learning from every interaction and
            taking autonomous action to optimize plans in real-time for the
            <strong> Traveler, the Agency, and the Operator </strong>simultaneously.

          </p>
          <img src={planner} alt="Intelligent Planner travel" className={classes['img-tech']}/>

          <h2 className={classes['project-subtitle2']}> Eco-Rolling Intelligent Connect </h2>
          <p > The module's primary goal is to ensure seamless,
            clear, and emotionally intelligent communication across all parties,
            regardless of language or communication channel.</p>

          <img src={chat} alt="Intelligent Connect" className={classes['img-tech']}/>
        </section>

      </main>
    </div>

  );
};
export default Tourism;